import React from 'react'
import { v4 as uuid4 } from 'uuid'
import {
  findIntermediatePointsByPrecedingDeliveryPoint,
  findIntermediatePointsPriorFirstLoading
} from 'components/Order/utils'
import { DeliveryPointType, IntermediatePointType } from 'components/Order/constants'
import { LoadingDeliveryPointDetails, UnloadingDeliveryPointDetails } from './DeliveryPointDetails'
import { FerryPassageDetails } from './FerryPassageDetails'
import { CustomsControlDetails } from './CustomsControlDetails'
import { CustomIntermediatePointDetails } from './CustomIntermediatePointDetails'

export function orderPointsListItemsFrom (loadingDeliveryPoints, unloadingDeliveryPoints, intermediatePoints) {
  const items = []
  const countByIntermediatePointType = {}

  findIntermediatePointsPriorFirstLoading(intermediatePoints)
    .map(ip => mapIntermediatePointToListItem(ip, countByIntermediatePointType))
    .forEach(it => items.push(it))

  loadingDeliveryPoints.forEach((dp, i) => {
    items.push(mapLoadingDeliveryPointToListItem(dp, i))
    findIntermediatePointsByPrecedingDeliveryPoint(intermediatePoints, i + 1, DeliveryPointType.Loading)
      .map(ip => mapIntermediatePointToListItem(ip, countByIntermediatePointType))
      .forEach(it => items.push(it))
  })

  unloadingDeliveryPoints.forEach((dp, i) => {
    items.push(mapUnloadingDeliveryPointToListItem(dp, i))
    findIntermediatePointsByPrecedingDeliveryPoint(intermediatePoints, i + 1, DeliveryPointType.Unloading)
      .map(ip => mapIntermediatePointToListItem(ip, countByIntermediatePointType))
      .forEach(it => items.push(it))
  })

  return items
}

const mapIntermediatePointToListItem = (ip, countByIntermediatePointType) => {
  const count = countByIntermediatePointType[ip.type] || 0
  const newCount = count + 1
  countByIntermediatePointType[ip.type] = newCount
  if (ip.type === IntermediatePointType.FerryPassage) {
    return mapFerryPassageToListItem(ip, newCount)
  }
  if (ip.type === IntermediatePointType.CustomsControl) {
    return mapCustomsControlToListItem(ip, newCount)
  }
  if (ip.type === IntermediatePointType.Custom) {
    return mapCustomIntermediatePointToListItem(ip, newCount)
  }
  throw new Error('Unknown intermediate point type')
}

const mapLoadingDeliveryPointToListItem = (dp, i) => ({
  ...newEmptyListItem(i + 1),
  getTitle: getLoadingDeliveryPointTitle,
  renderContent: (diffValues) => <LoadingDeliveryPointDetails deliveryPoint={dp} diffValues={diffValues}/>,
  data: dp
})

const getLoadingDeliveryPointTitle = t => t('order.delivery.loading.title')

const mapUnloadingDeliveryPointToListItem = (dp, i) => ({
  ...newEmptyListItem(i + 1),
  getTitle: getUnloadingDeliveryPointTitle,
  renderContent: (diffValues) => <UnloadingDeliveryPointDetails deliveryPoint={dp} diffValues={diffValues}/>,
  data: dp
})

const getUnloadingDeliveryPointTitle = t => t('order.delivery.unloading.title')

const mapFerryPassageToListItem = (fp, n) => ({
  ...newEmptyListItem(n),
  id: fp.id,
  getTitle: getFerryPassageTitle,
  renderContent: (diffValues) => <FerryPassageDetails ferryPassage={fp} diffValues={diffValues}/>,
  data: fp
})

const getFerryPassageTitle = t => t('order.details.ferryPassage.title')

const mapCustomsControlToListItem = (cc, n) => ({
  ...newEmptyListItem(n),
  id: cc.id,
  getTitle: getCustomsControlTitle,
  renderContent: (diffValues) => <CustomsControlDetails customsControl={cc} diffValues={diffValues}/>,
  data: cc
})

const getCustomsControlTitle = t => t('order.details.customsControl.title')

const mapCustomIntermediatePointToListItem = (cip, n) => ({
  ...newEmptyListItem(n),
  id: cip.id,
  getTitle: getCustomIntermediatePointTitle,
  renderContent: (diffValues) => <CustomIntermediatePointDetails customIntermediatePoint={cip}
                                                                 diffValues={diffValues}/>,
  data: cip
})

const getCustomIntermediatePointTitle = t => t('order.details.customIntermediatePoint.title')

const newEmptyListItem = number => ({
  id: uuid4(),
  number
})
